import { render } from "./LeftMenu.vue?vue&type=template&id=5a1b3602&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=5a1b3602&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1b3602"]])

export default __exports__